"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Shared header for every /app/more subpage (owner UX pass 2026-08-28): a
 * back ARROW at the top-left returning to the More hub — the standard
 * mobile-app pattern — instead of each page's own small "Back" text link
 * tucked to the right of the title.
 */

import { Link } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { useI18n } from "@/i18n"

export function MoreSubpageHeader({ title, headingId }: { title: string; headingId: string }) {
  const { t } = useI18n()
  return (
    <div className="flex items-center gap-2">
      <Link
        to="/app/more"
        aria-label={t("common.back")}
        className="flex size-10 shrink-0 items-center justify-center rounded-bb-full text-ink-2 transition-colors hover:bg-cream hover:text-ink"
      >
        <ArrowLeft className="size-5" aria-hidden="true" />
      </Link>
      <h1 id={headingId} className="font-display text-3xl font-bold tracking-tight text-ink">
        {title}
      </h1>
    </div>
  )
}
